import React from "react";
import { Form } from "react-bootstrap";
import _ from "lodash";

const RoleSelect = ({
  currentRole,
  roleOptions,
  disabled,
  orderedRoles = {},
  name = "user[role]",
}) => {
  function getOptions() {
    const options = [];

    if (currentRole) {
      const currentRoleOption = { label: _.startCase(currentRole), value: currentRole };
      options.push(currentRoleOption);
    }

    if (roleOptions) {
      options.push(...roleOptions);
    }

    return _.sortBy(options, (roleObj) => orderedRoles[roleObj.value]);
  }

  return (
    <Form.Select
      required
      disabled={disabled}
      type="text"
      name={name}
      defaultValue={currentRole || "basic_support_admin"}
    >
      {getOptions().map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default RoleSelect;
